export function ChevronDownIcon({ className = "" }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M6.74389 8.744C6.64599 8.8418 6.56832 8.95793 6.51533 9.08577C6.46233 9.2136 6.43506 9.35062 6.43506 9.489C6.43506 9.62739 6.46233 9.76441 6.51533 9.89224C6.56832 10.0201 6.64599 10.1362 6.74389 10.234L11.2909 14.791C11.3838 14.8841 11.4941 14.958 11.6156 15.0084C11.7371 15.0588 11.8674 15.0848 11.9989 15.0848C12.1304 15.0848 12.2607 15.0588 12.3822 15.0084C12.5036 14.958 12.614 14.8841 12.7069 14.791L17.2569 10.233C17.4542 10.0357 17.5651 9.76806 17.5651 9.489C17.5651 9.20995 17.4542 8.94232 17.2569 8.745C17.0596 8.54768 16.7919 8.43683 16.5129 8.43683C16.2338 8.43683 15.9662 8.54768 15.7689 8.745L11.9989 12.521L8.23089 8.745C8.13329 8.64731 8.01738 8.56981 7.88981 8.51693C7.76223 8.46406 7.62549 8.43684 7.48739 8.43684C7.34929 8.43684 7.21255 8.46406 7.08498 8.51693C6.9574 8.56981 6.8415 8.64731 6.74389 8.745V8.744Z"
        fill="#292A2E"
      />
    </svg>
  );
}
